import { motion } from "framer-motion";
import { COMPANY, STATS } from "@/lib/sipl-content";
import StatCounter from "./StatCounter";

export default function About() {
  return (
    <section id="about" data-testid="about-section" className="section-y bg-white">
      <div className="container-x grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.6 }}
          className="lg:col-span-7"
        >
          <div className="text-sm uppercase tracking-[0.22em] text-sipl-secondary mb-5 dash-accent">
            About Us
          </div>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl text-sipl-primary font-semibold tracking-tight leading-[1.08]">
            Built in {COMPANY.founded}, engineered for India's
            <span className="text-sipl-secondary"> sustainable decade.</span>
          </h2>
          <p className="mt-6 text-base text-sipl-fg/75 leading-relaxed max-w-2xl">
            {COMPANY.name} is a Noida-headquartered renewable energy and waste
            management company delivering end-to-end solar EPC, O&amp;M,
            municipal &amp; bio-waste solutions, rural water infrastructure and
            project management consultancy for government, PSUs and corporates.
          </p>

          <div className="mt-8 grid sm:grid-cols-2 gap-6">
            <div className="border-l-2 border-sipl-accent pl-5">
              <div className="text-xs uppercase tracking-[0.22em] text-sipl-muted mb-2">
                Mission
              </div>
              <p className="text-sipl-fg/85 leading-relaxed">
                Driving sustainable energy access and waste transformation —
                with engineering rigour and on-ground execution.
              </p>
            </div>
            <div className="border-l-2 border-sipl-secondary pl-5">
              <div className="text-xs uppercase tracking-[0.22em] text-sipl-muted mb-2">
                Vision
              </div>
              <p className="text-sipl-fg/85 leading-relaxed">
                To become India's leading catalyst for sustainable
                development across energy, waste and rural infrastructure.
              </p>
            </div>
          </div>
        </motion.div>

        <div className="lg:col-span-5 grid grid-cols-2 gap-8 content-start lg:pl-8 lg:border-l lg:border-sipl-line">
          {STATS.map((s) => (
            <StatCounter key={s.label} {...s} />
          ))}
        </div>
      </div>
    </section>
  );
}
